/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import ServiceEntry, {MaintainServiceEntryProps} from './ServiceEntry';
import {Entry} from './Services';

export interface ServiceEntriesProps extends MaintainServiceEntryProps {
  serviceEntries: Entry[];
}

/**
 * Handles displaying the given service entries as user friendly form fields.
 * 
 * ```typescript
 * 
 *  import ServiceEntries from './ServiceEntries';
 * 
 *  <ServiceEntries serviceEntries={serviceEntries}
 *    onUpdate={onUpdate}
 *    onDelete={onDelete} />
 * 
 * ```
 */
export const ServiceEntries = ({
  onUpdate,
  onDelete,
  serviceEntries
}: ServiceEntriesProps) => {
  return (
    <>
      {serviceEntries?.map(({id, service}) => (
        <ServiceEntry id={id}
          service={service}
          level={serviceEntries?.length}
          onUpdate={onUpdate}
          onDelete={onDelete} />
      ))}
    </>
  );
};

export default ServiceEntries;
